import { Typography } from "@mui/material";

export default function TableFilterTip(): JSX.Element {
  return (
    <Typography color="GrayText" marginBottom={1} variant="caption">
      Search, filter and sort using the "..." button at the top of each column
    </Typography>
  );
}
